import { render, staticRenderFns } from "./SendCreditConfirm.vue?vue&type=template&id=50e12a69&"
import script from "./SendCreditConfirm.vue?vue&type=script&lang=js&"
export * from "./SendCreditConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports